import {useMutation} from '@tanstack/react-query';
import {useState} from 'react';
import {ticketMutationAdapter} from '../../../../adapter/ticketMutationAdapter';
import {getSerializedPagewebError} from '../../../../errors/getSerializedPagewebError.function';
import {SerializedPagewebError} from '../../../../errors/SerializedPagewebError.interface';
import {
  FreeTicketType,
  SaleMethod,
  TodayGift,
} from '../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useLogin} from '../../../../user/useLogin.hook';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {useContentMyTicketQuery} from '../../../../wrapper/ticketWrapper';

export function useReceiveTicketFree({seriesId}: {seriesId: number}): {
  result?: TodayGift;
  error?: SerializedPagewebError;
  execute: (ticketUid: number) => void;
} {
  const [result, setResult] = useState<TodayGift>();
  const [error, setError] = useState<SerializedPagewebError>();
  const {data, refetch} = useContentHomeOverviewQuery(
    {seriesId},
    ONLY_DATA_CONFIG
  );
  const isCashTypeHome =
    data?.contentHomeOverview?.content?.saleMethod === SaleMethod.Cash;

  const {mutateAsync} = useMutation(ticketMutationAdapter.receiveTicketFree());

  const {isLogin, doLogin} = useLogin();
  const {refetch: refetchMyTicket} = useContentMyTicketQuery(
    {
      seriesId,
      includeWaitfree: true,
    },
    {
      enabled: isLogin && !!data && !isCashTypeHome,
    }
  );

  const callback = async (ticketUid: number) => {
    if (!isLogin) {
      doLogin();
      return;
    }
    try {
      const {receiveTicketFree} = await mutateAsync({
        input: {
          seriesId,
          ticketUid,
          type: FreeTicketType.TodayGift,
        },
      });
      refetch();
      setResult(receiveTicketFree);
      // receiveFreeTicket 한 경우 내 이용권을 갱신해줍니다.
      await refetchMyTicket();
    } catch (e) {
      setError(getSerializedPagewebError(e));
      setResult(undefined);
    }
  };
  return {
    result,
    error,
    execute: callback,
  };
}
